export const getCurrentBvId = ({ tireLinePage: { tireLineDetails }}) => tireLineDetails.bvId

export const getTireSizeNumber = ({ tireLinePage: { tireSizeNumber }}) => tireSizeNumber
